import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';
import breakpoints from '../utils/breakpoints';

gsap.registerPlugin(ScrollTrigger);

const mm = gsap.matchMedia();

function animateRows(section, rows, isMobile = false) {
  let isSameDirection = false;
  const rowHalfLength = rows.length / 2;

  rows.forEach((row, i) => {
    let x;
    let xEnd;
    if (isMobile) {
      if (i && i % 2 === 0) {
        isSameDirection = !isSameDirection;
      }
      [x, xEnd] = isSameDirection ? ['-75%', '25%'] : ['75%', '-25%'];
    } else {
      [x, xEnd] = rowHalfLength > i ? ['-100%', '100%'] : ['100%', '-100%'];
    }

    gsap.fromTo(
      row,
      { x },
      {
        x: xEnd,
        scrollTrigger: {
          trigger: section,
          start: 'top 100%',
          end: 'bottom 0%',
          scrub: true,
          fastScrollEnd: true,
        },
      },
    );
  });
}

mm.add(`(max-width: ${breakpoints.l}px)`, () => {
  gsap.utils.toArray('.paragraph-key-facts').forEach((section) => {
    const rows = section.querySelectorAll('.paragraph-key-facts-item--regular');
    animateRows(section, rows, true);
  });
});

mm.add(`(min-width: ${breakpoints.l}px)`, () => {
  gsap.utils.toArray('.paragraph-key-facts').forEach((section) => {
    const rows = section.querySelectorAll('.paragraph-key-facts-item');
    animateRows(section, rows);
  });
});
